export class RatingTitleModel {
  ratingTitleId: Number;
  titleTH: String;
  titleEN: String;
  src: String;
}



// WEBPACK FOOTER //
// ./src/app/model/rating/rating-title-model.ts